<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          الیاسل
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            اینجا آغاز ماجراجویی است 🚀
          </b-card-title>
          <b-card-text class="mb-2">
            ثبت نام کرده و از ماجراجویی لذت ببرید
          </b-card-text>

          <!-- form -->
          <validation-observer ref="registerForm">
            <b-form class="auth-register-form mt-2">
              <!-- username -->
              <b-form-group label="نام" label-for="register-username">
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  rules="required"
                >
                  <b-form-input
                    id="register-username"
                    v-model="username"
                    name="register-username"
                    :state="errors.length > 0 ? false : null"
                    placeholder="حسین حسینی"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group label="ایمیل" label-for="register-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="register-email"
                    v-model="userEmail"
                    name="register-email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="example@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group label-for="register-password" label="رمز عبور">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required|passwordLength"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="register-password"
                      v-model="password"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      :state="errors.length > 0 ? false : null"
                      name="register-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        :icon="passwordToggleIcon"
                        class="cursor-pointer"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!--Register As -->
              <b-form-group label-for="register-as" label="نوع کاربری">
                <validation-provider
                  #default="{ errors }"
                  name="Role"
                  rules="required"
                >
                  <b-form-radio-group
                    v-model="selectedRole"
                    :options="roleOptions"
                    name="register-as"
                    stacked
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Status"
                  :rules="{ required: { allowFalse: false } }"
                >
                  <b-form-checkbox
                    id="register-privacy-policy"
                    v-model="status"
                    name="checkbox-1"
                  >
                    با
                    <b-link>شرایط و قوانین</b-link>
                    موافقم
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                variant="primary"
                block
                type="submit"
                @click.prevent="validationForm"
              >
                ثبت نام
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>قبلا ثبت نام کرده اید؟</span>
            <b-link :to="{ name: 'login' }">
              <span>&nbsp;وارد شوید</span>
            </b-link>
          </p>

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Register-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import fa from 'vee-validate/dist/locale/fa.json'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import { passwordLength } from '../../libs/utils/validations'

export default {
  components: {
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormRadioGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      username: '',
      userEmail: '',
      password: '',
      selectedRole: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
      passwordLength,
      roleOptions: [
        {
          text: 'ناشر تبلیغات (کسب درآمد از طریق اپلیکیشن)',
          value: 'Publisher',
        },
        { text: 'تبلیغ‌دهنده (تعریف کمپین‌های تبلیغاتی)', value: 'Advertiser' },
        { text: 'هر دو', value: 'both' },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    localize({
      fa: {
        messages: fa.messages,
        names: {
          Email: 'ایمیل',
          Password: 'رمز عبور',
          Username: 'نام',
          Role: 'نوع کاربری',
          Status: 'موافقت با شرایط و قوانین',
        },
      },
    })
    localize('fa')
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          useJwt
            .register({
              DisplayName: this.username,
              Email: this.userEmail,
              Password: this.password,
              Roles: this.selectedRole,
            })
            .then(response => {
              if (!response.data.success) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.generateAlertTitle(response.data.message),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                  },
                })
                return
              }

              const tokens = JSON.parse(response.data.data)

              useJwt.setToken(tokens.AccessToken)
              useJwt.setRefreshToken(tokens.RefreshToken)

              const newAbilities = [
                ...this.$ability.j,
                {
                  action: 'read',
                  subject: 'LoggedIn',
                },
              ]

              this.$ability.update(newAbilities)

              const userData = {
                ...tokens,
                ability: newAbilities,
              }

              localStorage.setItem('userData', JSON.stringify(userData))

              // console.log(`token is: ${useJwt.getToken()}`)
              // axios.get('jwt/GetMe').then(res => console.log(res))

              this.$router.replace({ name: 'home' })
            })
        }
      })
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
